import { useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function PopupExperience() {
  const API = process.env.REACT_APP_BACKEND_URL;
  const [status, setStatus] = useState(null); // null | loading | ok | err
  const [errMsg, setErr] = useState("");
  const [form, setForm] = useState({ name: "", business: "", email: "", phone: "", city: "", state: "", date: "", message: "" });
  const change = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading"); setErr("");
    try {
      const res = await fetch(`${API}/api/inquiry`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(d?.detail || "Please try again."); }
      setStatus("ok");
    } catch (err) { setStatus("err"); setErr(err.message); }
  };

  return (
    <div className="App bg-black min-h-screen text-white flex flex-col">
      <Navbar />
      <main className="flex-1 px-4 md:px-10 max-w-3xl mx-auto pt-28 md:pt-36 pb-20 md:pb-28 w-full">
        <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#F4C10A] mb-3">Retailers · Venues · Stores</div>
        <h1 className="font-wide uppercase text-4xl sm:text-5xl md:text-6xl leading-[0.95]">Host an FTA Pop-Up</h1>
        <p className="mt-5 font-body text-white/70 text-base md:text-lg leading-relaxed max-w-2xl">
          Interested in bringing an FTA × Paper Planes pop-up experience to your store or venue? Tell us about your space — we'll be in touch.
        </p>
        {status === "ok" ? (
          <div data-testid="inquiry-success" className="mt-10 border border-[#F4C10A] p-8 text-center">
            <div className="font-wide uppercase text-2xl text-[#F4C10A]">Inquiry Received</div>
            <p className="mt-3 font-body text-white/80">Thanks for reaching out — we'll follow up at the email you provided.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field name="name" label="Your Name" value={form.name} onChange={change} required />
            <Field name="business" label="Business / Store / Venue" value={form.business} onChange={change} required />
            <Field name="email" label="Email" type="email" value={form.email} onChange={change} required />
            <Field name="phone" label="Phone" type="tel" value={form.phone} onChange={change} />
            <Field name="city" label="City" value={form.city} onChange={change} required />
            <Field name="state" label="State" value={form.state} onChange={change} required />
            <div className="md:col-span-2"><Field name="date" label="Proposed Date (if known)" value={form.date} onChange={change} /></div>
            <label className="md:col-span-2 block">
              <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/60 mb-2">Tell us about your venue</div>
              <textarea name="message" rows={5} value={form.message} onChange={change}
                className="w-full bg-transparent border border-white/25 focus:border-[#F4C10A] outline-none px-4 py-3 text-white placeholder-white/30 font-body"/>
            </label>
            {status === "err" && <div data-testid="inquiry-error" className="md:col-span-2 text-red-400 text-sm">{errMsg}</div>}
            <button type="submit" disabled={status === "loading"} data-testid="inquiry-submit"
              className="md:col-span-2 bg-[#F4C10A] text-black font-display uppercase text-sm tracking-[0.22em] py-4 hover:bg-[#FFDF73] transition-colors disabled:opacity-50">
              {status === "loading" ? "Sending…" : "Submit Inquiry"}
            </button>
          </form>
        )}
      </main>
      <Footer />
    </div>
  );
}

function Field({ name, label, value, onChange, required, type = "text" }) {
  return (
    <label className="block">
      <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/60 mb-2">{label}{required && " *"}</div>
      <input name={name} value={value} onChange={onChange} required={required} type={type}
        data-testid={`inquiry-field-${name}`}
        className="w-full bg-transparent border border-white/25 focus:border-[#F4C10A] outline-none px-4 py-3 text-white placeholder-white/30 font-body" />
    </label>
  );
}
